import { render, staticRenderFns } from "./privacy.vue?vue&type=template&id=049a2e18&"
import script from "./privacy.vue?vue&type=script&lang=js&"
export * from "./privacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049a2e18')) {
      api.createRecord('049a2e18', component.options)
    } else {
      api.reload('049a2e18', component.options)
    }
    module.hot.accept("./privacy.vue?vue&type=template&id=049a2e18&", function () {
      api.rerender('049a2e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/indexDisposition/privacy.vue"
export default component.exports